/**
 * Asynchronously loads the component for TestDecisionPopup
 */

import { lazyLoad } from 'utils/loadable';

export const TestDecisionPopup = lazyLoad(
  () => import('./index'),
  module => module.TestDecisionPopup
);
